import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

const base =
  "group inline-flex min-h-[48px] items-center justify-center gap-2.5 px-7 py-3 text-[13px] font-semibold uppercase tracking-[0.14em] transition-colors duration-300 disabled:cursor-not-allowed disabled:opacity-60 md:text-sm";

const variants = {
  primary: "bg-ink text-white hover:bg-taupe",
  outline: "border border-ink bg-transparent text-ink hover:bg-ink hover:text-white",
  light: "bg-ivory text-ink hover:bg-champagne hover:text-ink",
  outlineLight:
    "border border-ivory/40 bg-transparent text-ivory hover:bg-ivory hover:text-ink",
  gold: "bg-champagne text-ink hover:bg-champagne-dark hover:text-white",
};

export const ButtonLink = ({
  to,
  href,
  children,
  variant = "primary",
  className = "",
  arrow = true,
  external = false,
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  const icon = arrow ? (
    external ? (
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    ) : (
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    )
  ) : null;

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
        {icon}
      </Link>
    );
  }
  return (
    <a
      href={href}
      className={cls}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      {...rest}
    >
      {children}
      {icon}
    </a>
  );
};

export const TextLink = ({ to, href, children, dark = false, external = false, ...rest }) => (
  <LinkOrA
    to={to}
    href={href}
    external={external}
    className={`group inline-flex items-center gap-2 text-[13px] font-semibold uppercase tracking-[0.16em] transition-colors ${
      dark ? "text-champagne hover:text-ivory" : "text-ink hover:text-taupe"
    }`}
    {...rest}
  >
    <span className="border-b border-champagne pb-1">{children}</span>
    <ArrowRight className="h-4 w-4 text-champagne transition-transform duration-300 group-hover:translate-x-1" />
  </LinkOrA>
);

const LinkOrA = ({ to, href, external, children, ...rest }) => {
  if (to) return <Link to={to} {...rest}>{children}</Link>;
  return (
    <a href={href} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...rest}>
      {children}
    </a>
  );
};
